import React, { useState } from 'react';
import './ScaledImg.css';

interface ScaledImgProps {
  src: string;
  alt?: string;
}

const ScaledImg: React.FC<ScaledImgProps> = ({ src, alt }) => {
  const [enlarged, setEnlarged] = useState(false);
  return (
    <div className="scaled-img-container">
      <img src={src} alt={alt} className={enlarged?"original-image":"small-image"} onClick={ (e) => {setEnlarged((e) => !e)} }/>
    </div>
  );
};

export default ScaledImg;
